import Amplify, { Auth, Hub } from 'aws-amplify'

import { history } from 'redux/store'
import { API_URI, AWS_USER_POOL_ID, AWS_CLIENT_ID, AWS_COGNITO_REGION } from 'utils/constants'

const listener = data => {
  switch (data.payload.event) {
    case 'signIn':
      history.push('/')
      break
    case 'signOut':
      history.push('/auth')
      break
    case 'signIn_failure':
      console.error('user sign in failed')
      break
    case 'configured':
      console.log('the Auth module is configured')
  }
}

Hub.listen('auth', listener)

Amplify.configure({
  Auth: {
    // REQUIRED - Amazon Cognito Region
    region: AWS_COGNITO_REGION,
    // OPTIONAL - Amazon Cognito User Pool ID
    userPoolId: AWS_USER_POOL_ID,
    // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
    userPoolWebClientId: AWS_CLIENT_ID,
  },
  API: {
    endpoints: [
      {
        name: 'BOC_API',
        endpoint: API_URI,
        custom_header: async () => ({
          'access-token': (await Auth.currentSession()).getIdToken().getJwtToken(), // .idToken.jwtToken
        }),
      },
    ],
  },
})

export const logIn = (username: string, password: string) => Auth.signIn(username.toLowerCase(), password)

export const updatePassword = (user: any, password: string, requiredAttributes?: any) =>
  Auth.completeNewPassword(user, password, requiredAttributes)

export const logOut = () => Auth.signOut()

export const forgotPassword = (username: string) => Auth.forgotPassword(username)

export const resetPassword = (username: string, code: string, newPassword: string) =>
  Auth.forgotPasswordSubmit(username, code, newPassword)

export const getCurrentUser = async () => Auth.currentAuthenticatedUser()

export const getUserPermission = async () => {
  const user = (await Auth.currentSession()).getIdToken().payload
  return JSON.parse(user['custom:app-permissions'] || '{}').iotmon
}
